import { z } from 'zod';

import { Option } from '../../types/Option';

enum Compliance {
    CE = 'CE',
    UL = 'UL',
    CSA = 'CSA',
    CCC = 'CCC',
    CURRENT_OS = 'currentOS',
    ODCA = 'ODCA',
    EMERGE = 'emergeAlliance',
    OTHER = 'other',
}

const options = [
    {
        value: Compliance.CE,
        label: 'CE',
    },
    {
        value: Compliance.UL,
        label: 'UL',
    },
    {
        value: Compliance.CSA,
        label: 'CSA',
    },
    {
        value: Compliance.CCC,
        label: 'CCC',
    },
    {
        value: Compliance.CURRENT_OS,
        label: 'CurrentOS',
    },
    {
        value: Compliance.ODCA,
        label: 'ODCA',
    },
    {
        value: Compliance.EMERGE,
        label: 'EMerge Alliance',
    },
    {
        value: Compliance.OTHER,
        label: 'Other',
    },
] as Option<Compliance>[];

const Compliances = {
    validator: z.array(z.nativeEnum(Compliance)),
    options,
};

export { Compliance, Compliances };
